import { createVanIconComponent } from "./van"

const Records = createVanIconComponent("records")
export default Records
